import type { CategoryDto } from './types';

/** Неархивные основные категории группы — только они мешают убрать группу в архив (§2.1):
 *  архивные скрыты из списков, и «пустую на вид» группу нельзя было бы убрать. */
export function activeChildCount(groupId: string, categories: Pick<CategoryDto, 'parentId' | 'isArchived'>[]): number {
  return categories.filter((c) => c.parentId === groupId && !c.isArchived).length;
}

/** Почему группу нельзя отправить в архив прямо сейчас; `null` — можно. Бэкенд проверяет то же правило
 *  (`CATEGORY_GROUP_NOT_EMPTY`), здесь оно нужно, чтобы кнопка сразу объясняла причину. */
export function groupArchiveBlockReason(
  group: Pick<CategoryDto, 'id' | 'parentId'>,
  categories: Pick<CategoryDto, 'parentId' | 'isArchived'>[],
): string | null {
  if (group.parentId !== null) return null;
  const active = activeChildCount(group.id, categories);
  return active > 0 ? `В группе есть подкатегории (${active}) — сначала отправьте их в архив или перенесите в другую группу` : null;
}
